import { css } from "@emotion/react"
import { getColor } from "@illa-design/react"
import { applyMobileStyle, pxToRem } from "@/style"

export const modalMaskStyle = css`
  background-color: ${getColor("white", "05")};
  backdrop-filter: blur(5px);
`

export const modalStyle = css`
  border: unset;
  width: 486px;
  min-width: 486px;
  background: ${getColor("white", "01")};
  border: 1px solid ${getColor("grayBlue", "08")};
  box-shadow: 0 4px 16px rgb(0 0 0 / 8%);
  border-radius: 8px;
  overflow: hidden;

  ${applyMobileStyle(css`
    width: ${pxToRem(716)};
    min-width: ${pxToRem(716)};
    border-radius: ${pxToRem(16)};
  `)}
`

export const modalCloseIconStyle = css`
  position: absolute;
  width: 24px;
  height: 24px;
  line-height: 10px;
  text-align: center;
  top: 18px;
  right: 17px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${getColor("grayBlue", "02")};
`

export const decorateStyle = css`
  width: 100%;

  ${applyMobileStyle(css`
    height: 405rem;
  `)};
`

export const headerStyle = css`
  padding: 16px;
`

export const titleStyle = css`
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  margin-bottom: 8px;

  ${applyMobileStyle(css`
    font-size: 36rem;
    line-height: 44rem;
    margin-bottom: 16rem;
  `)};
`

export const descriptionStyle = css`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: ${getColor("grayBlue", "03")};

  ${applyMobileStyle(css`
    font-size: 28rem;
    line-height: 34rem;
  `)};
`

export const footerStyle = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px;
`

export const upgradeButtonStyle = css`
  align-self: center;
`

export const priceContentStyle = css`
  font-size: 12px;
  line-height: 20px;
  color: ${getColor("grayBlue", "03")};

  ${applyMobileStyle(css`
    font-size: 24rem;
    line-height: 40rem;
  `)};
`

export const priceStyle = css`
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: ${getColor("grayBlue", "02")};
`

const hiddenListContent = css`
  display: none;

  @media (min-width: 1024px) {
    display: block;
    padding: 4px 24px;
  }
`

export const blockListContent = css`
  padding: 4px 24px;
`

export const applyCardListStyle = (text?: string) => css`
  ${text ? blockListContent : hiddenListContent};
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: start;

  ${applyMobileStyle(css`
    gap: 16rem;
    font-size: 28rem;
    line-height: 48rem;
  `)};
`

export const doubtStyle = css`
  cursor: pointer;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;

  &:hover .tips {
    display: block;
  }

  ${applyMobileStyle(css`
    width: 32rem;
    height: 32rem;
  `)};
`

export const iconStyle = css`
  height: 16px;
  width: 16px;
  flex-shrink: 0;

  ${applyMobileStyle(css`
    width: 32rem;
    height: 32rem;
  `)};
`
